
import Close from 'vue-material-design-icons/Close.vue'
import Plus from 'vue-material-design-icons/Plus.vue'

import NcButton from '@nextcloud/vue/dist/Components/NcButton.js'
import NcCheckboxRadioSwitch from '@nextcloud/vue/dist/Components/NcCheckboxRadioSwitch.js'
import NcModal from '@nextcloud/vue/dist/Components/NcModal.js'
import NcTextField from '@nextcloud/vue/dist/Components/NcTextField.js'

import pollService from '../../services/pollService.js'

export default {
	name: 'NewMessagePollEditor',

	components: {
		NcCheckboxRadioSwitch,
		NcButton,
		NcModal,
		NcTextField,
		// Icons
		Close,
		Plus,
	},

	props: {
		token: {
			type: String,
			required: true,
		},
	},

	emits: ['close'],

	data() {
		return {
			isPrivate: false,
			isMultipleAnswer: false,
			pollQuestion: '',
			pollOptions: ['', ''],
		}
	},

	computed: {
		container() {
			return this.$store.getters.getMainContainerSelector()
		},

		isFilled() {
			return !!this.pollQuestion || this.pollOptions.some(option => option)
		},
	},

	methods: {
		// Remove a previously added option
		deleteOption(index) {
			this.pollOptions.splice(index, 1)
		},

		dismissEditor() {
			this.$emit('close')
		},

		addOption() {
			this.pollOptions.push('')
			this.$nextTick(() => {
				this.$refs.pollOption.at(-1).focus()
			})
		},

		async createPoll() {
			try {
				const response = await pollService.postNewPoll(
					this.token,
					this.pollQuestion,
					this.pollOptions,
					this.isPrivate ? 1 : 0,
					this.isMultipleAnswer ? 0 : 1)
				// Add the poll immediately to the store
				this.$store.dispatch('addPoll', {
					token: this.token,
					poll: response.data.ocs.data,
				})
				this.dismissEditor()
			} catch (error) {
				console.debug(error)
			}
		},

	},
}
